import * as React from 'react';
import { SVGProps } from 'react';

const IconIronMapSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.323 3.2 2 6.8 3.161 12 7 14l5-1.5L14 9l-1.161-5-3.871-2-4.645 1.2Z"
      fill="var(--color-bg-caution)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m9.028 1.468 4.245 2.194 1.258 5.416-2.196 3.844-5.386 1.615-4.225-2.201-1.258-5.631 2.542-3.94 5.02-1.297Zm-6.212 4.99 2.496-1.426L9.438 4h2.311L8.908 2.532 4.637 3.635 2.816 6.458ZM12.558 5H9.562l-3.874.968-2.981 1.704.776 3.476 2.829-1.616L10.438 8.5h2.933L12.558 5ZM7.05 13.463l-2.93-1.527 2.567-1.468 3.874-.968h2.576l-1.473 2.579-4.614 1.384Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconIronMapSizeS;
